import React from 'react';
import { Card, Row, Skeleton } from 'antd';
import './Comment.css';

const CommentLoading: React.FC = () => {
  return (
    <Card className="Comment-card" bodyStyle={{ padding: '12px' }}>
      <Row>
        <Skeleton
          className="Comment-card-skeleton"
          active
          title={false}
          paragraph={{ rows: 3 }}
        />
      </Row>
    </Card>
  );
};

export default CommentLoading;
